import React from "react";
import { range } from "lodash";

import * as FormControl from "lib/components/FormControl";
import CSSModules from "lib/utils/css-modules";
import styles from "./DatesField.less";
import { getMaxDate, dateFormat } from "../common";

const daysOptions = range(0, 7).map((idx) => [idx, I18n.t(`papp.common.weekdayAbbreviations.${idx}`)]);

@CSSModules(styles)
export default class DatesField extends React.PureComponent {
  handleRangeChange([from, to]) {
    const { dates, onChange } = this.props;
    const nextDates = {
      ...dates,
      from,
      to,
    };
    onChange(nextDates);
  }

  handleDaysChange(days) {
    const { dates, onChange } = this.props;
    const nextDates = {
      ...dates,
      days,
    };
    onChange(nextDates);
  }

  render() {
    const { dates, errors } = this.props;

    return (
      <div styleName="dates-field">
        <FormControl.DateRangeFormGroup
          {...FormControl.addProps("accommodation.schedule.dateRange", { errors })}
          value={[dates.from, dates.to]}
          onChange={this.handleRangeChange.bind(this)}
          label={I18n.t("papp.accommodation.AccommodationSchedulerView.datesHeader")}
          isOutsideRange={(date) =>
            date < moment(moment().format(dateFormat)) || moment(moment(date).format(dateFormat)) > moment(getMaxDate())
          }
          required
        />
        <div styleName="days-of-week">
          <FormControl.MultipleCheckboxFormGroup
            {...FormControl.addProps("accommodation.schedule.days", { errors })}
            value={dates.days}
            onChange={this.handleDaysChange.bind(this)}
            options={daysOptions}
            withLabelsAbove
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/accommodation/AccommodationSchedulerView/DatesField.jsx